// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery {
    display: flex;
    justify-content: space-between;
    /* 每张图片间均匀分布 */
    align-items: center;
    padding: 20px;
}

.img-container {
    width: calc(100% / 6 - 10px);
    /* 保持每个容器同样的宽度并减去间距 */
    height: 300px;
    /* 固定高度 */
    margin: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    border-radius: 8px;
}

.img-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}



#sections-container {
    opacity: 0;
    transition: all 0.3s ease;
}

#sections-container:hover {
    opacity: 1;
}



#sections-container>#sections-top:hover {
    background-color: rgba(255, 255, 255, 0.7) !important;
}

#sections-container>#sections-bottom:hover {
    background-color: rgba(255, 255, 255, 0.7) !important;
}



#sections-container {
    cursor: pointer;
}

#sections-container2 {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

#sections-top,
#sections-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
}`, "",{"version":3,"sources":["webpack://./src/views/presentation-sections/Sections.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,WAAW;IACX,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;;;AAIA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;;;AAIA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;;;AAIA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".gallery {\n    display: flex;\n    justify-content: space-between;\n    /* 每张图片间均匀分布 */\n    align-items: center;\n    padding: 20px;\n}\n\n.img-container {\n    width: calc(100% / 6 - 10px);\n    /* 保持每个容器同样的宽度并减去间距 */\n    height: 300px;\n    /* 固定高度 */\n    margin: 5px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    border-radius: 8px;\n}\n\n.img-container img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n\n\n#sections-container {\n    opacity: 0;\n    transition: all 0.3s ease;\n}\n\n#sections-container:hover {\n    opacity: 1;\n}\n\n\n\n#sections-container>#sections-top:hover {\n    background-color: rgba(255, 255, 255, 0.7) !important;\n}\n\n#sections-container>#sections-bottom:hover {\n    background-color: rgba(255, 255, 255, 0.7) !important;\n}\n\n\n\n#sections-container {\n    cursor: pointer;\n}\n\n#sections-container2 {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#sections-top,\n#sections-bottom {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
